'use strict';

var Masonry = require('masonry-layout');

var masonry;

function init() {
	var $grid = $('.grid.useMasonry');
	if ($grid.length === 0)
		return;

	var $window = $(window);

	masonry = new Masonry('.grid.useMasonry', {
		// options
		itemSelector : '.grid__item',
		columnWidth : '.grid__item',
		percentPosition : true,
		transitionDuration : 0
	});

	$window.on('load', layout);
	$window.on('resize', layout);
	$grid.on('click', '.grid__item', layout);
	$(window).on('autoLoadedPages', layout); // We have auto loading of pages so relayout if pages loaded

	layout();
}

function layout() {
	var itemsLoading = masonry.$element.find('.grid__item:not(.masonry-loaded)');
	itemsLoading.addClass('masonry-loading');
	masonry.once('layoutComplete', function() {
		itemsLoading.addClass('masonry-loaded');
		itemsLoading.removeClass('masonry-loading');
	});

	masonry.reloadItems();
	masonry.layout();
}

module.exports = {
	init : init,
	layout : layout
};